/**
 * Calculate Akami CDN hit rate
 */
export function akamaiHitRate(): { akamai_hit_rate: number } | {} {
    try {
        const [hit, miss] = window.performance
            .getEntriesByType("resource")
            .map(({ serverTiming = [] }) =>
                serverTiming.find(
                    ({ name }) => name.includes("akam"), // akam OR cld-akam
                ),
            )
            .filter(Boolean)
            .reduce(
                ([hit, miss], { description }) =>
                    description.includes("hit") // Include "hit-near" for example
                        ? [++hit, miss]
                        : [hit, ++miss],
                [0, 0],
            );

        const akamai_hit_rate = (hit / (hit + miss)) * 100;

        return akamai_hit_rate ? { akamai_hit_rate } : {};
    } catch (error) {
        return {};
    }
}
